<template>
  <div>
    <v-expansion-panel-header
      class="pa-0 ma-0 app-list-card-expansion-header"
      v-if="driver"
    >
      <div class="d-flex algin-center justify-center justify-space-between">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="text-caption mr-1 font-weight-bold"
              v-if="driver.driver_name"
              v-bind="attrs"
              v-on="on"
            >
              {{ driver.driver_name }}
            </span>
          </template>
          <span class="text-capitalize">
            {{ `${fleetModule.driver} name` }}</span
          >
        </v-tooltip>

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-chip
                class="mr-1 text-capitalize font-weight-bold"
                :class="$helper.tripStatusColor(trip.status, true)"
                x-small
                v-if="trip.status"
                v-bind="attrs"
                v-on="on"
              >
                {{ trip.verbose_status }}
              </v-chip>
            </div>
          </template>
          <span class="text-capitalize"> {{ statusMapping.tripStatus }} </span>
        </v-tooltip> -->
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="px-0 py-2" v-if="driver">
      <v-row no-gutters >
        <v-col cols="6" class="pb-1">
          <DriverTooltipWithIcon
            v-if="driver.driver_contact_number"
            icon="mdi-phone"
            :text="driver.driver_contact_number"
            :label="`${fleetModule.driver} contact number`"
          />
        </v-col>
        <v-col cols="6" class="pb-1 text-right">
          <DriverTooltipWithIcon
            v-if="driver.vehicle_plate_no"
            icon="mdi-truck"
            :text="driver.vehicle_plate_no"
            :label="`${fleetModule.vehicle} Number`"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import { orderModule, fleetModule, tripModule, statusMapping } from "@/utils/moduleMapping";
import DriverTooltipWithIcon from '@/components/ModuleBasedComponents/Operation/DriverTooltipWithIcon.vue';

export default {
  components: { DriverTooltipWithIcon },
  props: {
    driver: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fleetModule,
      tripModule,
      statusMapping,
      orderModule,
      panel: [1],
    };
  },
};
</script>

<style scoped>
.v-expansion-panel::before {
  box-shadow: none !important;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: inherit !important;
}
.v-expansion-panel:not(:first-child)::after {
  border-top: none !important;
}
</style>
